// @flow

import {eventChannel} from 'redux-saga'
import firebase from 'firebase/app'

export type AuthStateChangedEvent = {
  user: ?User,
}

export function onAuthStateChanged() {
  return eventChannel(send => {
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      send({
        user,
      })
    })
    return () => {
      unsubscribe()
    }
  })
}
